import { HttpErrorResponse } from "@angular/common/http";
import { TutorProfile } from "src/app/_models/Tutor";
import { Userprofile } from "src/app/_models/Userprofile";

export interface TutorState {
  crudTutorLoader: boolean;
  crudTutorError: HttpErrorResponse;
  currentPageNumber: number;

  crudResult: Userprofile;
  tutorTableRecords: TutorProfile[];
  tutorRecordsLength: number;
  tutorTableError: HttpErrorResponse;

  tutorTableLoader: boolean;
  tableTutorError: boolean;
  isInitialLoadFlowReset: boolean;

  tutorUserProfile: Userprofile;

  groupTutorCount: string;
  groupTutorCountLoader: boolean;
  groupTutotCountError: HttpErrorResponse;

  hasAccessToLearner: boolean;
  hasAccessToLearnerLoader: boolean;
  hasAccessToLearnerError: any;
  
  tutorRecordCount: number;

  updateTutorAccountStatusLoader: boolean;
  isTutorAccountStatusUpdateSuccessful: boolean;
  updateTutorAccountStatusError: HttpErrorResponse;
}

export const initialTutorState: TutorState = {
  crudTutorLoader: false,
  crudTutorError: null,
  currentPageNumber: 0,

  crudResult: null,
  tutorTableRecords: [],
  tutorRecordsLength: 0,
  tutorTableError: null,

  tutorTableLoader: false,
  tableTutorError: null,
  isInitialLoadFlowReset: false,

  tutorUserProfile: null,

  groupTutorCount: null,
  groupTutorCountLoader: false,
  groupTutotCountError: null,

  hasAccessToLearner: null,
  hasAccessToLearnerLoader: false,
  hasAccessToLearnerError: null,

  tutorRecordCount: null,

  updateTutorAccountStatusLoader: false,
  isTutorAccountStatusUpdateSuccessful: false,
  updateTutorAccountStatusError: null
};
